import { z } from "zod/v4";

// SAMS (DVV result reporting) response schemas — mirror the Rust `onsand-sams`
// DTOs (camelCase). Reporting is admin-gated; non-admins get 403.

export const samsLandesverbandSchema = z.object({
	code: z.string(),
	name: z.string(),
	active: z.boolean(),
});
export type SamsLandesverband = z.infer<typeof samsLandesverbandSchema>;

export const samsSubmissionStatusSchema = z.enum(["succeeded", "failed"]);
export type SamsSubmissionStatus = z.infer<typeof samsSubmissionStatusSchema>;

export const samsSubmissionSchema = z.object({
	id: z.string().uuid(),
	tournamentId: z.string().uuid(),
	lvCode: z.string(),
	status: samsSubmissionStatusSchema,
	// `reference` is "STUB" while the service runs in stub mode (not transmitted).
	reference: z.string().nullable(),
	error: z.string().nullable(),
	submittedAt: z.coerce.date().nullable(),
	createdAt: z.coerce.date(),
});
export type SamsSubmission = z.infer<typeof samsSubmissionSchema>;

export const submitSamsReportSchema = z.object({
	tournamentId: z.string().uuid(),
	lvCode: z.string(),
});
export type SubmitSamsReport = z.infer<typeof submitSamsReportSchema>;
